import { render, staticRenderFns } from "./NumericalGroupAnonymisationField.vue?vue&type=template&id=5984fabc&"
import script from "./NumericalGroupAnonymisationField.vue?vue&type=script&lang=ts&"
export * from "./NumericalGroupAnonymisationField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports